import IntegrationIcon from 'assets/images/icons/menuSVG/clip-path-group.svg';
import CommonMenuIcon from 'components/commons/MenuIcon';
import { ROLE_LIST } from 'constants/index';

const getExternalIntegrationMenu = ({ $t, permission }) => {
    if (permission && permission.indexOf(ROLE_LIST.INTEGRATION_EDIT) !== -1) {
        return {
            id: 'external-integration-menu',
            title: $t('sidebar.OpMenuGroupExternalIntegration'),
            type: 'group',
            children: [
                {
                    id: 'integrations',
                    title: $t('sidebar.OpMenuGroupExternalIntegration'),
                    type: 'item',
                    url: '/integrations',
                    icon: CommonMenuIcon(IntegrationIcon),
                    breadcrumbs: false
                }
            ],
            show: permission && permission.indexOf(ROLE_LIST.INTEGRATION_EDIT) !== -1
        };
    }

    return [];
};

export default getExternalIntegrationMenu;
